/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function ToastController($mdToast, message) {
    var vm = this;

    vm.$onInit = function () {
        vm.message = message;

        vm.closeToast = closeToast;
    };

    function closeToast() {
        $mdToast.hide();
    }

}



// WEBPACK FOOTER //
// ./src/app/services/toast.controller.js